/******************************************************************************
 * @Author                : Jbristhuille<jbristhuille@gmail.com>              *
 * @CreatedDate           : 2025-02-05 15:34:16                               *
 * @LastEditors           : Jbristhuille<jbristhuille@gmail.com>              *
 * @LastEditDate          : 2025-03-05 14:45:04                               *
 *****************************************************************************/

/* SUMMARY
  * Imports
  * Components
  * Services
  * AdminInterventions: Admin interventions view
    * useEffect: Get workorders list
*/

/* Imports */
/***/

/* Components */
/***/

/* Services */
import { Workorders } from "../../../workorders/Workorders";
/***/

/**
* AdminInterventions: Admin interventions view
* Display interventions list for realm 
*/
export default function AdminInterventions() {
  
  return (
    <Workorders isAdminComponent />
  );
}
/***/
